module.exports = __webpack_public_path__ + "static/Portrait-of-Emil-min-eae2ac6c6771db901e68867ad9c10d87.jpg";